/*
 * @Description: file content
 * @Author: kayvor
 * @Date: 2020-04-01 18:28:16
 * @LastEditTime: 2020-04-01 18:28:29
 * @LastEditors: kayvor
 */

// import * as MUTATION from '../mutationTypes'

const state = {

}

const mutations = {

}

export const actions = {

}

export const getters = {

}

export default {
    state,
    mutations,
}
